import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist'

import { alert } from './alert.module';
import { authentication } from './authentication.module';
import { localization } from './localization.module';

const vuexPersist = new VuexPersist({
    key: 'navitrack-fcs',
    storage: window.localStorage
});

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        alert,
        authentication,
        localization
    },
    plugins: [vuexPersist.plugin]
});